import { render, staticRenderFns } from "./EditRating.vue?vue&type=template&id=46e7360f&"
import script from "./EditRating.vue?vue&type=script&lang=js&"
export * from "./EditRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports